import { render, staticRenderFns } from "./PopularCompany.vue?vue&type=template&id=597b2b94&"
import script from "./PopularCompany.vue?vue&type=script&lang=js&"
export * from "./PopularCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports